(() => {
  const SELECTOR = '[data-tour-sort]';
  const CONTROL_SELECTOR = '[data-tour-sort-control]';

  const getDateValue = (element) => {
    const raw = element.dataset.tourDate || '';
    const timestamp = Date.parse(raw);
    return Number.isNaN(timestamp) ? Number.POSITIVE_INFINITY : timestamp;
  };

  const sortGrid = (grid) => {
    const direction = grid.dataset.tourSort === 'desc' ? -1 : 1;
    const items = Array.from(grid.querySelectorAll('[data-tour-date]'));
    if (items.length < 2) return;

    items
      .map((item, index) => ({ item, index, date: getDateValue(item) }))
      .sort((a, b) => {
        if (a.date === b.date) return a.index - b.index;
        return (a.date - b.date) * direction;
      })
      .forEach(({ item }) => grid.appendChild(item));
  };

  const syncControlState = (control, direction) => {
    const wrapper = control.closest('[data-tour-sort-controls]');
    if (!wrapper) return;

    wrapper.querySelectorAll(CONTROL_SELECTOR).forEach((button) => {
      const isActive = button.dataset.sortDirection === direction;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  };

  const bindControl = (control) => {
    if (control.dataset.sortBound === 'true') return;
    control.dataset.sortBound = 'true';

    control.addEventListener('click', () => {
      const targetId = control.dataset.targetId;
      const direction = control.dataset.sortDirection || 'desc';
      if (!targetId) return;

      const grid = document.getElementById(targetId);
      if (!grid) return;

      grid.dataset.tourSort = direction;
      sortGrid(grid);
      syncControlState(control, direction);
    });
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(sortGrid);
    root.querySelectorAll(CONTROL_SELECTOR).forEach((control) => {
      bindControl(control);
      if (control.classList.contains('is-active')) {
        syncControlState(control, control.dataset.sortDirection || 'desc');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
